import { RequestService } from '../../../../common/services/RequestService';
import { GET_PROFILE_FILTERS } from '../constants';
import { dataAdjustmentProfileResponse } from './dataAdjustment';

export const getProfileFiltersRequest = async profileId => {
  const response = await RequestService.get(
    GET_PROFILE_FILTERS.replace('{profile_id}', profileId)
  );
  return response && dataAdjustmentProfileResponse(response.data);
};
